import Vue from 'vue';
import Vuex from 'vuex';
import persistedState from 'vuex-persistedstate';

import getters from './getters';
import actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

const state = {
  currentMenu: {},
  userInfo: {},
  currentOpenMenu: '/transport',
  showSideNav: false,
  currentProjectId: window.localStorage.getItem('CURRENT_PROJECT_ID') || '',
  authUrlList: {},
  globalEnumCollection: {
    accountStatusEnum: {
      0: {
        name: {
          CHN: '已禁用',
          ENG: 'Disabled',
        },
      },
      1: {
        name: {
          CHN: '正常',
          ENG: 'Normal',
        },
      },
      2: {
        name: {
          CHN: '已删除',
          ENG: 'Deleted',
        },
      },
    },
    accountTypeEnum: {
      10: {
        name: {
          CHN: '超级管理员',
          ENG: 'Super Admin',
        },
      },
      20: {
        name: {
          CHN: '企业用户',
          ENG: 'Company User',
        },
      },
      21: {
        name: {
          CHN: '站点用户',
          ENG: 'Station User',
        },
      },
      22: {
        name: {
          CHN: '终端用户',
          ENG: 'Terminal User',
        },
      },
      30: {
        name: {
          CHN: '工厂用户',
          ENG: 'Factory User',
        },
      },
      // 40: '设备用户',
    },
    accountTypeEnumByAdmin: {
      20: {
        name: {
          CHN: '企业用户',
          ENG: 'Company User',
        },
      },
      21: {
        name: {
          CHN: '站点用户',
          ENG: 'Station User',
        },
      },
      22: {
        name: {
          CHN: '终端用户',
          ENG: 'Terminal User',
        },
      },
      30: {
        name: {
          CHN: '工厂用户',
          ENG: 'Factory User',
        },
      },
    },
    accountTypeEnumByCompany: {
      21: {
        name: {
          CHN: '站点用户',
          ENG: 'Station User',
        },
      },
      22: {
        name: {
          CHN: '终端用户',
          ENG: 'Terminal User',
        },
      },
    },
    accountTypeEnumByStation: {
      22: {
        name: {
          CHN: '终端用户',
          ENG: 'Terminal User',
        },
      },
    },
    wareHouseTypeEnum: {
      1: {
        name: {
          CHN: '制冷库',
          ENG: 'Refrigeration',
        },
      },
      2: {
        name: {
          CHN: '常温库',
          ENG: 'Constant Temperature Storage',
        },
      },
    },
    onlineFlagEnum: {
      0: {
        name: {
          CHN: '离线',
          ENG: 'Offline',
        },
      },
      1: {
        name: {
          CHN: '在线',
          ENG: 'Online',
        },
      },
    },
    deviceTypeEnum: {
      0: {
        name: {
          CHN: '直连',
          ENG: 'Direct Connection',
        },
      },
      1: {
        name: {
          CHN: '节点',
          ENG: 'Node',
        },
      },
      2: {
        name: {
          CHN: '网关',
          ENG: 'Gateway',
        },
      },
      3: {
        name: {
          CHN: '蓝牙',
          ENG: 'Bluetooth',
        },
      },
    },

    alarmTypeEnum: {
      1: {
        name: {
          CHN: '温度超限',
          ENG: 'Temperature Overrun',
        },
      },
      2: {
        name: {
          CHN: '湿度超限',
          ENG: 'Humidity Overrun',
        },
      },
      3: {
        name: {
          CHN: '低电',
          ENG: 'Low Battery',
        },
      },
      4: {
        name: {
          CHN: '断电',
          ENG: 'Power Outage',
        },
      },
      5: {
        name: {
          CHN: '离线',
          ENG: 'Offline',
        },
      },
      6: {
        name: {
          CHN: '振动',
          ENG: 'Vibration',
        },
      },
      7: {
        name: {
          CHN: '倾斜',
          ENG: 'Tilt',
        },
      },
      8: {
        name: {
          CHN: '光照',
          ENG: 'Light',
        },
      },
      9: {
        name: {
          CHN: '温度预警',
          ENG: 'Temperature Warning',
        },
      },
      10: {
        name: {
          CHN: '湿度预警',
          ENG: 'Humidity Warning',
        },
      },
      11: {
        name: {
          CHN: '温度2超限',
          ENG: 'Temperature 2 Overrun',
        },
      },
      12: {
        name: {
          CHN: '温度3超限',
          ENG: 'Temperature 3 Overrun',
        },
      },
      13: {
        name: {
          CHN: '湿度2超限',
          ENG: 'Humidity 2 Overrun',
        },
      },
      14: {
        name: {
          CHN: '湿度3超限',
          ENG: 'Humidity 3 Overrun',
        },
      },
      15: {
        name: {
          CHN: '温度2预警',
          ENG: 'Temperature 3 Warning',
        },
      },
      16: {
        name: {
          CHN: '温度3预警',
          ENG: 'Temperature 3 Warning',
        },
      },
      17: {
        name: {
          CHN: '湿度2预警',
          ENG: 'Humidity 3 Warning',
        },
      },
      18: {
        name: {
          CHN: '湿度2预警',
          ENG: 'Humidity 3 Warning',
        },
      },
    },
    alarmExecutorTypeEnum: {
      1: {
        name: {
          CHN: '短信',
          ENG: 'SMS',
        },
      },
      2: {
        name: {
          CHN: '邮件',
          ENG: 'Email',
        },
      },
      3: {
        name: {
          CHN: '微信公众号',
          ENG: 'WeChat',
        },
      },
      4: {
        name: {
          CHN: '语音',
          ENG: 'Voice',
        },
      },
    },
    readStatusEnum: {
      0: {
        name: {
          CHN: '未阅',
          ENG: 'Unread',
        },
      },
      1: {
        name: {
          CHN: '已阅',
          ENG: 'Read',
        },
      },
    },
    recoverStatusEnum: {
      0: {
        name: {
          CHN: '未恢复',
          ENG: 'Unrecovered',
        },
      },
      1: {
        name: {
          CHN: '已恢复',
          ENG: 'Recovered',
        },
      },
    },
    locationAreaEnum: {
      1: {
        name: {
          CHN: '预冷区',
          ENG: 'PreCold',
        },
      },
      2: {
        name: {
          CHN: '释冷区',
          ENG: 'Release',
        },
      },
      3: {
        name: {
          CHN: '打包区',
          ENG: 'Pack',
        },
      },
      4: {
        name: {
          CHN: '回收区',
          ENG: 'Recycle',
        },
      },
    },
    iceBoxProcessStatusEnum: {
      0: {
        name: {
          CHN: '总冰盒',
          ENG: 'Total Ice Box',
        },
      },
      1: {
        name: {
          CHN: '待预冷',
          ENG: 'Treatment Cold',
        },
      },
      2: {
        name: {
          CHN: '预冷中',
          ENG: 'PreCold',
        },
      },
      3: {
        name: {
          CHN: '预冷完成',
          ENG: 'PreCold Finished',
        },
      },
      4: {
        name: {
          CHN: '释冷中',
          ENG: 'Release',
        },
      },
      5: {
        name: {
          CHN: '释冷完成',
          ENG: 'Release Finished',
        },
      },
      6: {
        name: {
          CHN: '释冷过久',
          ENG: 'Release Overdue',
        },
      },
      7: {
        name: {
          CHN: '运输中',
          ENG: 'Transport',
        },
      },
      8: {
        name: {
          CHN: '运输完成',
          ENG: 'Transport Finished',
        },
      },
    },
    iceBoxProcessStatusWithoutSiteEnum: {
      1: {
        name: {
          CHN: '待预冷',
          ENG: 'Treatment Cold',
        },
      },
      2: {
        name: {
          CHN: '预冷中',
          ENG: 'PreCold',
        },
      },
      3: {
        name: {
          CHN: '预冷完成',
          ENG: 'PreCold Finished',
        },
      },
      4: {
        name: {
          CHN: '释冷中',
          ENG: 'Release',
        },
      },
      5: {
        name: {
          CHN: '释冷完成',
          ENG: 'Release Finished',
        },
      },
      6: {
        name: {
          CHN: '释冷过久',
          ENG: 'Release Overdue',
        },
      },
    },
    transportStatusEnum: {
      0: {
        name: {
          CHN: '待运输',
          ENG: 'To Be Transported',
        },
      },
      1: {
        name: {
          CHN: '运输中',
          ENG: 'In Transit',
        },
      },
      2: {
        name: {
          CHN: '运输完成',
          ENG: 'Arrived',
        },
      },
      3: {
        name: {
          CHN: '取消运输',
          ENG: 'Cancelled',
        },
      },
    },
    sendParamStatusEnum: {
      0: {
        name: {
          CHN: '未下发',
          ENG: 'Unsent',
        },
      },
      1: {
        name: {
          CHN: '下发中',
          ENG: 'Sending',
        },
      },
      2: {
        name: {
          CHN: '下发完成',
          ENG: 'Sent',
        },
      },
    },
    shutdownStatusEnum: {
      0: {
        name: {
          CHN: '未操作',
          ENG: 'Unoperated',
        },
      },
      1: {
        name: {
          CHN: '关机中',
          ENG: 'Shutting Down',
        },
      },
      2: {
        name: {
          CHN: '已关机',
          ENG: 'Shut Down',
        },
      },
    },
    boxStatusEnum: {
      1: {
        name: {
          CHN: '可用',
          ENG: 'Available',
        },
      },
      2: {
        name: {
          CHN: '在运',
          ENG: 'In Transit',
        },
      },
      3: {
        name: {
          CHN: '待回收',
          ENG: 'To Be Recycled',
        },
      },
    },
    boxRecycleStatusEnum: {
      0: {
        name: {
          CHN: '未回收',
          ENG: 'Unrecycled',
        },
      },
      1: {
        name: {
          CHN: '已回收',
          ENG: 'Recycled',
        },
      },
    },
    iceBoxRecycleStatusEnum: {
      0: {
        name: {
          CHN: '未回收',
          ENG: 'Unrecycled',
        },
      },
      1: {
        name: {
          CHN: '已回收',
          ENG: 'Recycled',
        },
      },
    },
    deviceRecycleStatusEnum: {
      0: {
        name: {
          CHN: '未回收',
          ENG: 'Unrecycled',
        },
      },
      1: {
        name: {
          CHN: '已回收',
          ENG: 'Recycled',
        },
      },
    },
    tempStatusEnum: {
      1: {
        name: {
          CHN: '正常',
          ENG: 'Normal',
        },
      },
      2: {
        name: {
          CHN: '超温',
          ENG: 'Over Temperature',
        },
      },
    },
    assetTypeEnum: {
      0: {
        name: {
          CHN: '箱子',
          ENG: 'Box',
        },
      },
      1: {
        name: {
          CHN: '冰盒',
          ENG: 'Ice Box',
        },
      },
      2: {
        name: {
          CHN: '设备',
          ENG: 'Device',
        },
      },
      3: {
        name: {
          CHN: '冰盒架',
          ENG: 'Ice Box Shelf',
        },
      },
      4: {
        name: {
          CHN: '冰盒托盘',
          ENG: 'Ice Box Pallet',
        },
      },
      5: {
        name: {
          CHN: '冰盒筐',
          ENG: 'Ice Box Crate',
        },
      },
      6: {
        name: {
          CHN: '方仓',
          ENG: 'Mobile Shelter',
        },
      },
      7: {
        name: {
          CHN: '移动冷库',
          ENG: 'Mobile Cold Storage',
        },
      },
      8: {
        name: {
          CHN: '车辆',
          ENG: 'Vehicle',
        },
      },
    },
    assetCodeTypeEnum: {
      0: {
        name: {
          CHN: '仓库',
          ENG: 'Warehouse',
        },
      },
      1: {
        name: {
          CHN: '库位',
          ENG: 'Location',
        },
      },
      2: {
        name: {
          CHN: '冰箱',
          ENG: 'Refrigerator',
        },
      },
      3: {
        name: {
          CHN: '保温箱',
          ENG: 'Keeper',
        },
      },
      13: {
        name: {
          CHN: '方仓',
          ENG: 'Mobile Shelter',
        },
      },
      14: {
        name: {
          CHN: '移动冷库',
          ENG: 'Mobile Cold Storage',
        },
      },
      15: {
        name: {
          CHN: '车辆',
          ENG: 'Vehicle',
        },
      },
    },
    operateTypeEnum: {
      1: {
        name: {
          CHN: '入库',
          ENG: 'Inbound',
        },
      },
      2: {
        name: {
          CHN: '出库',
          ENG: 'Outbound',
        },
      },
      3: {
        name: {
          CHN: '打包',
          ENG: 'Pack',
        },
      },
      4: {
        name: {
          CHN: '回收',
          ENG: 'Recycle',
        },
      },
      5: {
        name: {
          CHN: '解绑',
          ENG: 'Unbind',
        },
      },
    },
    // 冰盒出入库的载体类型
    carrierTypeEnum: {
      1: {
        name: {
          CHN: '冰盒架',
          ENG: 'Ice Box Shelf',
        },
      },
      2: {
        name: {
          CHN: '冰盒托盘',
          ENG: 'Ice Box Pallet',
        },
      },
      3: {
        name: {
          CHN: '冰盒筐',
          ENG: 'Ice Box Crate',
        },
      },
      4: {
        name: {
          CHN: '/',
          ENG: '/',
        },
      },
    },
    // GPS开关
    gpsSwitchEnum: {
      0: {
        name: {
          CHN: '关闭',
          ENG: 'Close',
        },
      },
      1: {
        name: {
          CHN: '开启',
          ENG: 'Open',
        },
      },
    },
    // 亮屏时间
    brightScreenEnum: {
      0: {
        name: {
          CHN: '常亮',
          ENG: 'Always On',
        },
      },
      1: {
        name: {
          CHN: '15秒',
          ENG: '15 Seconds',
        },
      },
      2: {
        name: {
          CHN: '30秒',
          ENG: '30 Seconds',
        },
      },
      10: {
        name: {
          CHN: '1分钟',
          ENG: '1 Minute',
        },
      },
      20: {
        name: {
          CHN: '2分钟',
          ENG: '2 Minute',
        },
      },
      30: {
        name: {
          CHN: '3分钟',
          ENG: '3 Minute',
        },
      },
      40: {
        name: {
          CHN: '4分钟',
          ENG: '4 Minute',
        },
      },
      50: {
        name: {
          CHN: '5分钟',
          ENG: '5 Minute',
        },
      },
    },
    // 设备事件
    deviceEventEnum: {
      0: {
        name: {
          CHN: '开机',
          ENG: 'Power On',
        },
      },
      1: {
        name: {
          CHN: '关机',
          ENG: 'Power Off',
        },
      },
      2: {
        name: {
          CHN: '重启',
          ENG: 'Reboot',
        },
      },
      3: {
        name: {
          CHN: '断开电源',
          ENG: 'Power Disconnect',
        },
      },
      4: {
        name: {
          CHN: '连接电源',
          ENG: 'Power Connect',
        },
      },
      5: {
        name: {
          CHN: '开箱',
          ENG: 'Open Box',
        },
      },
      6: {
        name: {
          CHN: '关箱',
          ENG: 'Close Box',
        },
      },
      7: {
        name: {
          CHN: '短信下发参数',
          ENG: 'SMS Parameter',
        },
      },
      8: {
        name: {
          CHN: '平台下发参数',
          ENG: 'Platform Parameter',
        },
      },
      9: {
        name: {
          CHN: '进入飞行模式',
          ENG: 'Enter flight mode',
        },
      },
      10: {
        name: {
          CHN: '退出飞行模式',
          ENG: 'Exit flight mode',
        },
      },
      11: {
        name: {
          CHN: '振动',
          ENG: 'Vibration',
        },
      },
      12: {
        name: {
          CHN: '振动恢复',
          ENG: 'Vibration Recovery',
        },
      },
      13: {
        name: {
          CHN: '倾斜',
          ENG: 'Tilt',
        },
      },
      14: {
        name: {
          CHN: '倾斜恢复',
          ENG: 'Tilt Recovery',
        },
      },
      15: {
        name: {
          CHN: '光照',
          ENG: 'Light',
        },
      },
      16: {
        name: {
          CHN: '光照恢复',
          ENG: 'Light Recovery',
        },
      },
    },
    // 短信充值
    smsRechargeEnum: {
      1: {
        name: {
          CHN: '充值',
          ENG: 'Recharge',
        },
      },
      2: {
        name: {
          CHN: '返还',
          ENG: 'Return',
        },
      },
    },
    // 导出类型
    exportTypeEnum: {
      1: {
        name: {
          CHN: '数据列表',
          ENG: 'Data List',
        },
      },
      2: {
        name: {
          CHN: '数据报告',
          ENG: 'Data Report',
        },
      },
      3: {
        name: {
          CHN: '告警记录',
          ENG: 'Alarm Record',
        },
      },
      4: {
        name: {
          CHN: '批量列表',
          ENG: 'Batch List',
        },
      },
      5: {
        name: {
          CHN: '设备列表',
          ENG: 'Device List',
        },
      },
    },
    assetStatusEnum: {
      0: {
        name: {
          CHN: '禁用',
          ENG: 'Disable',
        },
      },
      1: {
        name: {
          CHN: '启用',
          ENG: 'Enable',
        },
      },
    },
    carTypeEnum: {
      1: {
        name: {
          CHN: '常温车',
          ENG: 'Regular Car',
        },
      },
      2: {
        name: {
          CHN: '冷藏车',
          ENG: 'Cold Car',
        },
      },
      3: {
        name: {
          CHN: '冷冻车',
          ENG: 'Freeze Car',
        },
      },
    },
    exportResultEnum: {
      0: {
        name: {
          CHN: '生成中',
          ENG: 'Generating',
        },
      },
      1: {
        name: {
          CHN: '已生成',
          ENG: 'Generated',
        },
      },
      2: {
        name: {
          CHN: '生成失败',
          ENG: 'Generate Failed',
        },
      },
    },
    deviceServiceStatusEnum: {
      0: {
        name: {
          CHN: '正常',
          ENG: 'Normal',
        },
      },
      1: {
        name: {
          CHN: '过期',
          ENG: 'Expired',
        },
      },
    },
    weekEnum: {
      name: {
        CHN: {
          1: '周一',
          2: '周二',
          3: '周三',
          4: '周四',
          5: '周五',
          6: '周六',
          7: '周日',
        },
        ENG: {
          1: 'Monday',
          2: 'Tuesday',
          3: 'Wednesday',
          4: 'Thursday',
          5: 'Friday',
          6: 'Saturday',
          7: 'Sunday',
        },
      },
    },
  },
  menuList: [
    { icon: 'el-icon-monitor', title: '设备查看', url: '/transport-monitor-forDeviceUser', authUserType: [40] },
    {
      icon: 'el-icon-truck',
      title: 'transportManagement',
      url: '/transport',
      authUserType: [10, 20, 21],
      children: [
        {
          title: 'transportList',
          url: '/transport-list',
          authUserType: [10, 20, 21],
        },
        {
          title: 'transportMonitoring',
          url: '/transport-monitor',
          authUserType: [10, 20, 21],
        },
        {
          title: 'transportOrder',
          url: '/transportOrder-list',
          authUserType: [10, 20, 21],
        },
        {
          title: 'groupManagement',
          url: '/group-list',
          authUserType: [10, 20, 21],
        },
        {
          title: 'groupDevice',
          url: '/group-device',
          authUserType: [10, 20, 21],
        },
      ],
    },
    {
      icon: 'el-icon-receiving',
      title: 'processManagement',
      url: '/process',
      authUserType: [10, 20, 21],
      children: [
        {
          title: 'iceboxProcess',
          url: '/iceBox-process',
          authUserType: [10, 20, 21],
        },
      ],
    },
    {
      icon: 'el-icon-receiving',
      title: 'equipmentManagement',
      url: '/device',
      authUserType: [10, 20, 21],
      children: [
        {
          title: 'deviceList',
          url: '/device-list',
          authUserType: [10, 20, 21],
        },
        {
          title: 'gatewayList',
          url: '/device-sx-gateway-list',
          authUserType: [10, 20, 21],
        },
        {
          title: 'deviceParameters',
          url: '/device-param',
          authUserType: [10, 20, 21],
        },
        {
          title: 'deviceEvent',
          url: '/device-event',
          authUserType: [10, 20, 21],
        },
        {
          title: 'deviceMonitoring',
          url: '/device-monitor',
          authUserType: [10, 20, 21],
        },
      ],
    },
    /* { icon: 'el-icon-coin', title: '资产管理', url: '/333-list' }, */
    { icon: 'el-icon-s-cooperation', title: 'assetData', url: '/asset-device', authUserType: [10, 20, 21] },
    {
      icon: 'el-icon-coin',
      title: 'asset',
      url: '/assets',
      authUserType: [10, 20, 21],
      children: [
        {
          title: 'warehouse',
          url: '/warehouse-list',
          authUserType: [10, 20, 21],
        },
        {
          title: 'location',
          url: '/location-list',
          authUserType: [10, 20, 21],
        },
        {
          title: 'refrigerator',
          url: '/fridge-list',
          authUserType: [10, 20, 21],
        },
        {
          title: 'box',
          url: '/box-list',
          authUserType: [10, 20, 21],
        },
        {
          title: 'icebox',
          url: '/iceBox-list',
          authUserType: [10, 20, 21],
        },
        {
          title: 'iceboxShelf',
          url: '/iceBoxShelf-list',
          authUserType: [10, 20, 21],
        },
        {
          title: 'iceboxPallet',
          url: '/iceBoxPallet-list',
          authUserType: [10, 20, 21],
        },
        {
          title: 'vehicleManagement',
          url: '/car-list',
          authUserType: [10, 20, 21],
        },
        {
          title: 'mobileColdStorage',
          url: '/coldStore-list',
          authUserType: [10, 20, 21],
        },
        {
          title: 'mobileShelter',
          url: '/shelter-list',
          authUserType: [10, 20, 21],
        },
      ],
    },
    {
      icon: 'el-icon-bell',
      title: 'alarmManagement',
      url: '/alarm',
      authUserType: [10, 20, 21],
      children: [
        {
          title: 'alarmInfoManagement',
          url: '/alarm-list',
          authUserType: [10, 20, 21],
        },
        {
          title: 'alarmProjectManagement',
          url: '/alarmExecutor-list',
          authUserType: [10, 20, 21],
        },
      ],
    },
    {
      icon: 'el-icon-s-tools',
      title: 'systemManagement',
      url: '/config',
      authUserType: [10, 20, 21],
      children: [
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: 'accountManagement',
          url: '/account-list',
          authUserType: [10, 20, 21],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: 'company',
          url: '/company-list',
          authUserType: [10],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: 'site',
          url: '/station-list',
          authUserType: [10, 20],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: 'companySms',
          url: '/company-sms-recharge-list',
          authUserType: [10],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: 'smsRecords',
          url: '/sms-send-log-list',
          authUserType: [10, 20, 21],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: 'companyVoice',
          url: '/company-voice-recharge-list',
          authUserType: [10],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: 'voiceRecord',
          url: '/voice-send-log-list',
          authUserType: [10, 20, 21],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: 'deviceService',
          url: '/device-service-term',
          authUserType: [10],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: 'globalConfig',
          url: '/mail-config',
          authUserType: [10, 20],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: 'iceboxLog',
          url: '/log-list',
          authUserType: [10, 20],
        },
      ],
    },
    {
      icon: 'el-icon-s-custom',
      title: 'userCenter',
      url: '/user-center',
      authUserType: [10, 20, 21],
      children: [
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: 'userInfo',
          url: '/account-setting',
          authUserType: [10, 20, 21],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: 'download',
          url: '/export-data-list',
          authUserType: [10, 20, 21],
        },
      ],
    },
  ],
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  strict: process.env.NODE_ENV !== 'production',
  plugins: [persistedState({ storage: window.sessionStorage })],
});



// WEBPACK FOOTER //
// ./src/store/index.js